import React from 'react';
import Icon from '../atoms/Icon';

function AwardIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox='0 0 32 29'>
      <g fill='none' fillRule='evenodd' stroke-linejoin='round' stroke='black' stroke-width='2.41667' stroke-miterlimit='10'>
        <path d='M23.9081 2.41668C23.9081 2.41668 24.7721 1.20834 26.5834 1.20834C28.2472 1.20834 30.2084 2.47709 30.2084 4.83334C30.2084 8.71209 24.1667 9.95909 24.1667 14.5C24.1667 15.6866 25.375 16.9082 25.375 16.9082'/>
        <path d='M6.04167 16.9082C6.04167 16.9082 7.25001 15.6866 7.25001 14.5C7.25001 9.95909 1.20834 8.71209 1.20834 4.83334C1.20834 2.47709 3.16947 1.20834 4.83334 1.20834C6.64342 1.20834 7.50859 2.41668 7.50859 2.41668'/>
        <path d='M7.25 2.41669C7.25 10.3047 11.7075 22.9583 15.6878 22.9583C19.668 22.9583 24.1667 10.353 24.1667 2.41669H7.25Z'/>
        <path d='M18.125 24.1667H13.2917C11.2895 24.1667 9.66669 25.7894 9.66669 27.7917H21.75C21.75 25.7894 20.1272 24.1667 18.125 24.1667Z'/>
      </g>

      <circle cx='15.7083' cy='9.66665' r='3.625' fill='#F47321' stroke='black' stroke-width='2.41667'/>
    </Icon>
  );
}

export default React.forwardRef(AwardIcon);